/**
 * BillDetectiveCrossLinkBanner — small "Looking for X? See Bill Detective."
 * banner used on adjacent pages (PR-cost-predictor, Customer-PL, AI Feature P&L,
 * Unit Economics) so users always know where the per-engineer / per-commit /
 * per-customer drill-down lives.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowRight } from 'lucide-react';

export default function BillDetectiveCrossLink({ message, testid = 'bd-crosslink' }) {
  return (
    <div
      className="mb-6 flex items-center justify-between gap-4 rounded-xl bg-emerald-500/5 ring-1 ring-emerald-500/20 px-4 py-3 text-sm"
      data-testid={testid}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Search className="w-4 h-4 text-emerald-300 flex-shrink-0" />
        <span className="text-slate-300 truncate">{message}</span>
      </div>
      <Link
        to="/bill-detective"
        className="inline-flex items-center gap-1.5 text-emerald-200 hover:text-emerald-100 font-medium whitespace-nowrap"
        data-testid={`${testid}-link`}
      >
        Open Bill Detective <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
}
